import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled render error:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24,
          background: '#090e17', color: '#e4eaf5', fontFamily: '"Inter Variable", Inter, system-ui, sans-serif',
          textAlign: 'center',
        }}>
          <h1 style={{ margin: 0, fontSize: 20 }}>Something went wrong</h1>
          <pre style={{
            maxWidth: 640, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            background: '#172130', border: '1px solid #b4cfed21',
            borderRadius: 8, padding: '12px 16px', fontSize: 12, color: '#ff9aa0',
          }}>{this.state.error.message}</pre>
          <div style={{ display: 'flex', gap: 12 }}>
            <button type="button" onClick={() => this.setState({ error: null })} style={{
              padding: '10px 20px', minHeight: 48, borderRadius: 8, border: '1px solid #5d6b85',
              background: 'transparent', color: '#e4eaf5', cursor: 'pointer',
            }}>Try again</button>
            <button type="button" onClick={() => window.location.reload()} style={{
              padding: '10px 20px', minHeight: 48, borderRadius: 8, border: 'none',
              background: '#5664d0', color: '#ffffff', cursor: 'pointer', fontWeight: 600,
            }}>Reload app</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
